import React from 'react';
import mapUnavailable from './assets/map.png';

import styles from './YaMapUnavailable.module.scss';

export default function YaMapUnavailable() {
  return (
    <>
      <img
        className={styles.image}
        src={mapUnavailable}
        alt="Ошибка. Возникли проблемы при загрузке карты."
      />
      <div className={styles.errorText}>
        <div className={styles.title}>Ошибка</div>
        <div className={styles.description}>Возникли проблемы при загрузке карты</div>
      </div>
    </>
  );
}
